<mat-card *ngIf="context$ | async; let context">
    <mat-card-title>Welcome {{ context.user.profile.displayName }}</mat-card-title>
    <mat-card-subtitle>Please enable the Facebook Page that you want to integrate with UDM.</mat-card-subtitle>
    <mat-card-content>
        <mat-list>
            <mat-list-item *ngFor="let integration of integrations$ | async" class="integration">
                <mat-slide-toggle (click)="toggle(integration)" [checked]="integration.channel">{{ integration.page.name }}</mat-slide-toggle>
            </mat-list-item>
        </mat-list>
    </mat-card-content>
</mat-card>